import {Form, Input, message, Modal, TreeSelect} from 'antd'
import {SActionBtn, SFormList, SLowcodeList, STableActions} from 'shj-components'
import {config} from './config.tsx'
import TreeMenu from './TreeMenu'
import {useDeepCompareEffect, useRequest, useSetState} from 'ahooks'
import {tableApiFunc, treeFormat} from '@/utils/data.ts'
import {
    addContentCategory,
    deleteContentCategory,
    deleteContentTag,
    queryContentCategoryList,
    queryContentTagList,
    saveOrUpdateContentTag,
    updateContentCategory,
} from '@/services/content.ts'
import {useMemo, useRef} from 'react'
import {getUser} from "shj-utils";

const categoryType = 'tag'
const defaultParams = {categoryType: categoryType, parentId: 0}

function ArticleManage() {
    const [form] = Form.useForm()

    const tableRef = useRef<any>()

    const [state, setState]: any = useSetState({checkTree: []})

    const {runAsync: runSaveAsync} = useRequest(addContentCategory, {
        manual: true,
    })
    const {runAsync: runDeleteAsync} = useRequest(deleteContentCategory, {
        manual: true,
    })
    const {
        data: categoryList = [],
        loading: treeLoading,
        runAsync: runCategoryList,
    }: any = useRequest(queryContentCategoryList, {
        defaultParams: [defaultParams],
    })
    const { runAsync: runEditAsync} = useRequest(updateContentCategory, {
        manual: true,
    })
    const {loading: tageLoading, runAsync: runTageAsync} = useRequest(saveOrUpdateContentTag, {
        manual: true,
    })

    const treeData = useMemo(
        () => treeFormat(categoryList, {
            children: 'childList',
            format: (item,option) => ({...item, disabled: (item.childList || []).length, level:option.level})
        }),
        [categoryList]
    )

    useDeepCompareEffect(() => {
        tableRef.current.reload()
    }, state.checkTree)

    const onOk = () => {
        form.validateFields().then(value => {
            let params = {
                ...(state.data ?? {}),
                ...value,
            }
            if (state.data?.id) {
                params = {
                    categoryId: value.categoryId,
                    tagNameList: [value.tagName],
                    tagId: state.data?.id,
                }
            }
            runTageAsync(params).then(() => {
                setState({open: false})
                tableRef.current.reload()
            })
        })
    }
    const onEditChange = ({type, values}: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            let apiFunc = runEditAsync
            if (type === 'add') {
                apiFunc = runSaveAsync
            } else if (type === 'delete') {
                apiFunc = runDeleteAsync
            }

            let params: any = {
                ...values,
                parentId: values?.parentId ?? 0,
                categoryName: values.name,
                categoryType: categoryType,
            }
            if (type === 'delete') {
                params = {
                    id: values.id,
                }
            }

            apiFunc(params)
                .then(res => {
                    runCategoryList(defaultParams)
                    resolve(res)
                })
                .catch(e => {
                    reject(e)
                })
        })
    }

    const onTreeMenuClick = (keys: Array<string>) => {
        setState({checkTree: keys})
    }

    const onRemove = (id: string) => {
        deleteContentTag({id}).then(() => {
            message.success('删除成功')
            tableRef.current.reload()
        })
    }

    const onAddOrEdit = (data: any = {}) => {
        setState({open: true, data: data})
        form.resetFields()
        form.setFieldsValue(data)
    }

    const extensions = {
        request: {
            fetchList: tableApiFunc(queryContentTagList, {
                data: {categoryId: state.checkTree[0]},
                paginationInBody: true,
                fieldNames: {current: 'current'},
            }),
        },
        events: {
            onAdd: () => onAddOrEdit({tagNameList: ['']}),
        },
        customRender: {
            actionRender(_: null, record: Record<string, any>) {
                const user = getUser();
                return (
                     record.createdBy === user?.ucenterUserId && (
                        <STableActions>
                            <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
                            <SActionBtn isDelete onClick={() => onRemove(record.id)}>
                                删除
                            </SActionBtn>
                        </STableActions>
                    )
                )
            },
        },
    }
    return (
        <div>
            <div style={{display: 'flex'}}>
                <Modal
                    open={state.open}
                    title="标签管理"
                    onCancel={() => setState({open: false})}
                    confirmLoading={tageLoading}
                    onOk={onOk}
                >
                    <Form form={form}>
                        <Form.Item label="分类" name="categoryId" rules={[{required: true}]}>
                            <TreeSelect
                                treeData={treeData}
                                fieldNames={{label: 'categoryName', value: 'id', children: 'childList'}}
                                treeDefaultExpandAll
                            />
                        </Form.Item>
                        {state.data?.tagName ? (
                            <Form.Item name="tagName" label="标签" rules={[{required: true}]}>
                                <Input/>
                            </Form.Item>
                        ) : (
                            <SFormList name="tagNameList" addType={['icon']} leastOne={true}>
                                <Form.Item style={{flex: 1}} label="标签" rules={[{required: true}]}>
                                    <Input/>
                                </Form.Item>
                            </SFormList>
                        )}
                    </Form>
                </Modal>
                <div>
                    <TreeMenu
                        value={state.checkTree}
                        onClick={onTreeMenuClick}
                        addDisabled={() => false}
                        treeData={treeData}
                        loading={treeLoading}
                        fieldNames={{title: 'categoryName', key: 'id', children: 'childList'}}
                        onEditChange={onEditChange}
                    />
                </div>
                <SLowcodeList ref={tableRef} searchMode={'group'} config={config} {...extensions} />
            </div>
        </div>
    )
}

export default ArticleManage
